import React, { useState } from "react";
import styled from "styled-components/macro";

const Container = styled.div`
  padding: 20px;
  color: var(--grey-0);

  ul {
    ul {
      margin-left: 20px;
    }
  }
  li {
    list-style-type: disc;
    margin-left: 20px;
    margin-bottom: 4px;
    line-height: 1.25em !important;
  }
  p {
    line-height: 1.25em !important;
  }
  h3 {
    margin-bottom: 4px;
  }
`;

const MuseGuidelines = () => {
  const [showMore, setShowMore] = useState(() => {
    const savedState = localStorage.getItem("muse-show-more");
    return savedState !== null ? JSON.parse(savedState) : true;
  });

  const toggleShowMore = () => {
    setShowMore((prevShowMore) => {
      const newShowMore = !prevShowMore;
      localStorage.setItem("muse-show-more", JSON.stringify(newShowMore));
      return newShowMore;
    });
  };

  return (
    <Container>
      <p>Muse works best with Beats that are a little bit more like scenes compared to traditional beats.</p>
      <br />
      {showMore && (
        <>
          <h3>Sweet Spot amount of plot / action:</h3>
          <p>
            <em>
              George is delivering a new tractor to a farmer in Guelph Ontario. Show George’s anxiety as he drives down the dirt road. The farmer should be affable, and invite George inside for
              coffee. The delivery goes as planned, however, George accidentally leaves his wallet at the farm.
            </em>
          </p>
          <br />
          <h3>Too much plot:</h3>
          <p>
            <em>George delivers a truck.. he realizes he left his wallet and goes back.. then George delivers a monkey to a zookeeper... then he delivers a new car to a chauffeur.</em> (Each of these
            deliveries should be its own scene)
          </p>
          <br />
          <h3>Not enough detail:</h3>
          <p>
            <em>George delivers a truck to a farmer.</em> (This gives Muse a lot of freedom to do whatever it wants, use at your own risk)
          </p>
          <br />
          <h3>Best Practices:</h3>
          <ul>
            <li>Make sure you specify important details in each beat:</li>
            <ul>
              <li>Which characters are in the scene or not</li>
              <li>Where it takes place</li>
              <li>Pacing considerations (should this develop slowly? should it wrap up quickly?)</li>
              <li>Time of day</li>
              <li>Specific beginning or ending</li>
            </ul>
            <li>
              If you write very very detailed Scenes, you might be better off using Expand to expand them, instead of sending overloaded scenes to Muse. Generate Chapter is best if you have a good
              idea of what you want but not every detail.
            </li>
          </ul>
        </>
      )}
      <a
        href="#"
        onClick={toggleShowMore}
      >
        {showMore ? "Show less..." : "Show more..."}
      </a>
    </Container>
  );
};

export default MuseGuidelines;
